


























import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import HuntingLicenseOrderFull = Orders.HuntingLicenseOrderFull;

@Component
export default class SeasonComponent extends Vue {
  @Prop({ required: true, type: Object })
  value!: HuntingLicenseOrderFull;
}
